<template>
  <div id="tableHeader">
    <div class="content_btn" v-show="!headerShow">
      <el-button @click="deleteBatches" size="small">批量删除</el-button>
      <el-button @click="treatment" size="small" :disabled="batchDisable">批量违规处理</el-button>
      <el-button
        @click="downData"
        :disabled="btnDisable"
        size="small"
        style="float:right"
        v-show="downShow"
        v-loading="loading"
        element-loading-spinner="el-icon-loading"
      >下载数据</el-button>
    </div>
    <div class="state_all">
      <div style="display: flex;">
        <i class="el-icon-warning" style="margin-top: 8px;margin-right: 2px;"></i>
        <span v-if="chekTableNum.date" class="date">{{chekTableNum.date}}</span>
        共
        <span style="margin-left: 2px;margin-right: 2px;">{{chekTableNum.all}}</span> 项
        <div v-if="selectAll">
          ，已选择
          <span>{{chekTableNum.check}}</span> 项
        </div>
        <span class="pointer" v-if="selectAll">
          <span @click="allCheck">勾选全部</span>/
          <span @click="cancelAllCheck">取消勾选</span>
        </span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "tableHeader",
  props: {
    chekTableNum: {
      type: Object
    },
    batchDisable: {
      type: Boolean
    },
    headerShow: {
      type: Boolean,
      default: true
    },
    brandStore: {
      type: Boolean
    },
    downShow: {
      type: Boolean
    },
    selectAll: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      loading: false,
      btnDisable: false,
    };
  },
  methods: {
    changeBtnDisable() {
      this.btnDisable = !this.btnDisable;
      this.loading = !this.loading;
    },
    downData() {
      this.changeBtnDisable();
      this.$emit("exportIllegalExcel");
    },
    deleteBatches() {
      this.$emit("deleteBatches");
    },
    treatment() {
      this.$emit("treatment");
    },
    allCheck() {
      this.$emit("allCheck");
    },
    cancelAllCheck() {
      this.$emit("cancelAllCheck");
    }
  }
};
</script>

<style  lang="scss">
#tableHeader {
  font-size: 12px;
  .el-loading-spinner {
    top: 101%;
  }
  .state_all {
    height: 28px;
    border: 1px solid #108cee;
    background-color: #e6f7ff;
    border-radius: 5px;
    line-height: 28px;
    margin-bottom: 8px;
    margin-top: 8px;
    color: #333;
    padding: 0 0 0 20px;
    font-size: 14px;
    .el-icon-warning {
      color: #108cee;
    }
    span {
      color: #108cee;
    }
    .date {
      color: #333;
      display: inline-block;
      margin-right:20px;
    }
  }
  .pointer {
    cursor: pointer;
  }
}
</style>
